"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SceneTreeManager = void 0;
const THREE = __importStar(require("three"));
const viewer_rendering_engine_camera_engine_1 = require("@shapediver/viewer.rendering-engine.camera-engine");
const viewer_rendering_engine_light_engine_1 = require("@shapediver/viewer.rendering-engine.light-engine");
const viewer_shared_math_1 = require("@shapediver/viewer.shared.math");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const gl_matrix_1 = require("gl-matrix");
const SDObject_1 = require("../objects/SDObject");
const ThreejsData_1 = require("../types/ThreejsData");
const SceenTreeManagerUtils_1 = require("./sceneTree/SceenTreeManagerUtils");
const SDTFUtils_1 = require("./sceneTree/SDTFUtils");
const ThreeJsDataUtils_1 = require("./sceneTree/ThreeJsDataUtils");
class SceneTreeManager {
    constructor(_renderingEngine) {
        this._renderingEngine = _renderingEngine;
        this._eventEngine = viewer_shared_services_1.EventEngine.instance;
        this._performanceEvaluator = viewer_shared_services_1.PerformanceEvaluator.instance;
        this._scene = new THREE.Scene();
        this._stateEngine = viewer_shared_services_1.StateEngine.instance;
        this._tree = viewer_shared_node_tree_1.Tree.instance;
        this._boundingBox = new viewer_shared_math_1.Box();
        this._directionalLightData = [];
        this._hiddenCamera = new THREE.PerspectiveCamera();
        this._lastRendererType = viewer_shared_types_1.RENDERER_TYPE.STANDARD;
        this._lastRootVersion = "";
        this._newRendererType = false;
        this._suspendSceneUpdates = false;
        this._scene.background = new THREE.Color("#ffffff");
    }
    get boundingBox() {
        return this._boundingBox;
    }
    get lastRendererType() {
        return this._lastRendererType;
    }
    get lastRootVersion() {
        return this._lastRootVersion;
    }
    get mainNode() {
        return this._mainConvertedObject;
    }
    get scene() {
        return this._scene;
    }
    get suspendSceneUpdates() {
        return this._suspendSceneUpdates;
    }
    set suspendSceneUpdates(value) {
        this._suspendSceneUpdates = value;
    }
    init() { }
    /**
     * Convert the data of the scene graph node into the format of the implementation.
     *
     * @param data the data element
     * @param obj the corresponding type node
     */
    updateData(treeNodeData, treeNode, convertedObject, filter = { transformationOnly: false }, isVisibleInHierarchy = true) {
        var _a;
        let dataChild;
        if (this._renderingEngine.type === viewer_shared_types_1.RENDERER_TYPE.ATTRIBUTES) {
            if (treeNodeData instanceof viewer_shared_node_tree_1.GeometryData) {
                (0, SDTFUtils_1.injectAttributeData)(this._renderingEngine, this._currentSDTFOverview, treeNode, treeNodeData);
            }
        }
        else {
            const sdtfTransform = treeNode.getTransformation("sdtf");
            if (sdtfTransform)
                treeNode.removeTransformation(sdtfTransform);
            if (treeNodeData instanceof viewer_shared_node_tree_1.GeometryData)
                treeNodeData.attributeMaterial = null;
        }
        switch (true) {
            case treeNodeData instanceof viewer_shared_node_tree_1.GeometryData:
                {
                    // We search for the instance matrices data in the parent of our current node
                    // We are currently at the primitive level and the instance matrices are stored at the mesh level
                    const instanceTransformationData = (_a = treeNode.parent) === null || _a === void 0 ? void 0 : _a.data.find((d) => d instanceof viewer_shared_node_tree_1.InstanceData);
                    if (filter.transformationOnly === false) {
                        dataChild = this._renderingEngine.geometryLoader.load(treeNodeData, instanceTransformationData);
                        // Three.js Object3Ds can only have one parent. If the
                        // same GeometryData is referenced by multiple tree nodes,
                        // the cache returns the same mesh each time. Adding it to
                        // a second node silently removes it from the first. Clone
                        // only when this would happen (different existing parent).
                        if (dataChild.parent !== null &&
                            dataChild.parent !== convertedObject) {
                            dataChild = dataChild.clone();
                        }
                        this._renderingEngine.geometryLoader.registerGeometryObject(treeNodeData, dataChild);
                        dataChild.userData.SDtype = SDObject_1.SD_DATA_TYPE.GEOMETRY;
                        dataChild.userData.SDid = treeNodeData.id;
                        dataChild.userData.SDversion = treeNodeData.version;
                        convertedObject.add(dataChild);
                    }
                }
                break;
            case treeNodeData instanceof ThreejsData_1.ThreejsData:
                {
                    dataChild = treeNodeData.obj;
                    treeNodeData.obj.userData.SDtype =
                        SDObject_1.SD_DATA_TYPE.THREEJS;
                    treeNodeData.obj.userData.SDid =
                        treeNodeData.id;
                    treeNodeData.obj.userData.SDversion =
                        treeNodeData.version;
                    convertedObject.add(dataChild);
                    // set the currently used environment map
                    (0, ThreeJsDataUtils_1.assignEnvironmentMapForThreeJsDataObject)(treeNodeData, this._renderingEngine.environmentMapLoader
                        .environmentMap, this._renderingEngine.environmentMapLoader.type, this._renderingEngine.environmentMapIntensity, this._renderingEngine.environmentMapRotation);
                }
                break;
            case treeNodeData instanceof viewer_rendering_engine_light_engine_1.AbstractLight:
                if (filter.transformationOnly === false) {
                    const threeLight = this._renderingEngine.lightLoader.load(treeNodeData, convertedObject);
                    if (threeLight) {
                        dataChild = threeLight;
                        dataChild.userData.SDtype = SDObject_1.SD_DATA_TYPE.LIGHT;
                        dataChild.userData.SDid = treeNodeData.id;
                        dataChild.userData.SDversion = treeNodeData.version;
                    }
                }
                if (treeNodeData instanceof viewer_rendering_engine_light_engine_1.DirectionalLight &&
                    treeNodeData.useNodeData === false)
                    this._directionalLightData.push(treeNodeData);
                break;
            case treeNodeData instanceof viewer_rendering_engine_camera_engine_1.AbstractCamera:
                if (filter.transformationOnly === false) {
                    const threeCamera = this._renderingEngine.cameraManager.load(treeNodeData, convertedObject);
                    if (threeCamera) {
                        dataChild = threeCamera;
                        dataChild.userData.SDtype = SDObject_1.SD_DATA_TYPE.CAMERA;
                        dataChild.userData.SDid = treeNodeData.id;
                        dataChild.userData.SDversion = treeNodeData.version;
                    }
                }
                break;
            case treeNodeData instanceof viewer_shared_node_tree_1.HTMLElementAnchorData:
                if (filter.transformationOnly === false) {
                    this._renderingEngine.htmlElementAnchorLoader.load(treeNode, treeNodeData, isVisibleInHierarchy);
                    const existingAnchor = convertedObject.children.find((o) => !(o instanceof SDObject_1.SDObject) &&
                        o.userData.SDtype ===
                            SDObject_1.SD_DATA_TYPE.HTML_ELEMENT_ANCHOR &&
                        o.userData.SDid === treeNodeData.id &&
                        o.userData.SDversion === treeNodeData.version);
                    if (!existingAnchor) {
                        const dataChild = new THREE.Object3D();
                        dataChild.userData.SDtype =
                            SDObject_1.SD_DATA_TYPE.HTML_ELEMENT_ANCHOR;
                        dataChild.userData.SDid = treeNodeData.id;
                        dataChild.userData.SDversion = treeNodeData.version;
                        convertedObject.add(dataChild);
                    }
                }
                break;
            default:
                break;
        }
        if (dataChild)
            (0, SceenTreeManagerUtils_1.assignBoundingBox)(treeNode, treeNodeData, this._renderingEngine.id, dataChild);
    }
    /**
     * Update the current node via the scene graph node.
     * Convert the data if needed.
     *
     * @param treeNode the scene graph node
     * @param obj the current type object
     */
    updateNode(treeNode = this._tree.root, obj, filter = { transformationOnly: false }, visibleInHierarchy = true) {
        // Resolve the converted object if not provided
        if (obj === undefined) {
            obj = this.resolveConvertedObject(treeNode, filter, visibleInHierarchy);
            if (!obj)
                return;
        }
        const convertedObject = obj;
        // reset bounding boxes
        this.resetBoundingBoxes(treeNode);
        // cleanup obsolete data and children
        if (filter.transformationOnly === false) {
            this.cleanupObsoleteData(treeNode, convertedObject);
            this.cleanupObsoleteChildren(treeNode, convertedObject);
        }
        const isVisible = this.isNodeVisible(treeNode);
        const isVisibleInHierarchy = visibleInHierarchy && isVisible;
        // convert all data items of the current node
        // old versions will be replaced by new ones
        // Create a lookup map for efficient access to converted children
        const convertedChildrenMap = new Map();
        for (const child of convertedObject.children) {
            if (child instanceof SDObject_1.SDObject) {
                convertedChildrenMap.set(child.SDid, child);
            }
        }
        for (let i = 0, len = treeNode.data.length; i < len; i++) {
            const dataItem = treeNode.data[i];
            const convertedObjectData = convertedChildrenMap.get(dataItem.id);
            if (!convertedObjectData ||
                convertedObjectData.SDversion !== dataItem.version ||
                this._newRendererType) {
                this.updateData(dataItem, treeNode, convertedObject, filter, isVisibleInHierarchy);
            }
            else {
                (0, SceenTreeManagerUtils_1.assignBoundingBox)(treeNode, dataItem, this._renderingEngine.id, convertedObjectData);
            }
        }
        // Update or create child nodes
        for (let i = 0, len = treeNode.children.length; i < len; i++) {
            const treeNodeChild = treeNode.children[i];
            const childConvertedObject = convertedChildrenMap.get(treeNodeChild.id);
            this.processChildTreeNode(treeNodeChild, convertedObject, childConvertedObject, filter, isVisibleInHierarchy);
            this.unionChildBoundingBoxes(treeNode, treeNodeChild, isVisible);
        }
        convertedObject.visible = isVisible;
        convertedObject.applyTransformation(treeNode.nodeMatrix);
    }
    updateSceneTree(rootTreeNode) {
        var _a, _b;
        // check if we currently have the same root version
        if (this._tree.root.version === this._lastRootVersion &&
            this._renderingEngine.type === this._lastRendererType)
            return;
        // check if scene tree updates are currently suspended
        if (this._suspendSceneUpdates)
            return;
        this._lastRootVersion = this._tree.root.version;
        this._newRendererType =
            this._renderingEngine.type !== this._lastRendererType;
        this._lastRendererType = this._renderingEngine.type;
        if (this._renderingEngine.closed)
            return;
        this._performanceEvaluator.startSection("sceneTreeUpdate." + this._lastRootVersion);
        const oldBB = this._boundingBox.clone();
        this._boundingBox = new viewer_shared_math_1.Box();
        this._renderingEngine.lightLoader.shadowMapCount = 0;
        if (!this._mainConvertedObject) {
            this._mainConvertedObject = new SDObject_1.SDObject(rootTreeNode.id, rootTreeNode.version);
            const oldObj = rootTreeNode.convertedObject[this._renderingEngine.id];
            rootTreeNode.convertedObject[this._renderingEngine.id] =
                this._mainConvertedObject;
            if (rootTreeNode.updateCallbackConvertedObject)
                rootTreeNode.updateCallbackConvertedObject(this._mainConvertedObject, oldObj, this._renderingEngine.id);
            this._scene.add(this._mainConvertedObject);
        }
        this._currentSDTFOverview = (0, SDTFUtils_1.createSDTFOverview)(rootTreeNode);
        this.updateNode(rootTreeNode, this._mainConvertedObject);
        this._boundingBox =
            rootTreeNode.boundingBoxViewport[this._renderingEngine.id].clone();
        // directional lights need to be with the bounding box
        this._directionalLightData.forEach((dl) => {
            var _a;
            // check if the data has stored converted object
            const convertedObject = ((_a = ((dl.convertedObject[this._renderingEngine.id]))) === null || _a === void 0 ? void 0 : _a.parent);
            if (!convertedObject)
                return;
            this._renderingEngine.lightLoader.adjustToBoundingBox(dl, convertedObject, this._boundingBox);
        });
        this._directionalLightData = [];
        const bbChanged = this._boundingBox.min[0] !== oldBB.min[0] ||
            this._boundingBox.min[1] !== oldBB.min[1] ||
            this._boundingBox.min[2] !== oldBB.min[2] ||
            this._boundingBox.max[0] !== oldBB.max[0] ||
            this._boundingBox.max[1] !== oldBB.max[1] ||
            this._boundingBox.max[2] !== oldBB.max[2];
        if (bbChanged) {
            if (!((_a = this._stateEngine.viewportEngines[this._renderingEngine.id]) === null || _a === void 0 ? void 0 : _a.boundingBoxCreated.resolved) &&
                !this._boundingBox.isEmpty())
                (_b = this._stateEngine.viewportEngines[this._renderingEngine.id]) === null || _b === void 0 ? void 0 : _b.boundingBoxCreated.resolve(true);
            this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.SCENE.SCENE_BOUNDING_BOX_CHANGE, {
                viewportId: this._renderingEngine.id,
                boundingBox: {
                    min: gl_matrix_1.vec3.clone(this._boundingBox.min),
                    max: gl_matrix_1.vec3.clone(this._boundingBox.max),
                },
            });
        }
        if (this._boundingBox.isEmpty()) {
            // check if all outputs that should be loaded at the start of a session are loaded
            // if the bounding box is empty then, emit the event
            if (Object.values(this._stateEngine.sessionEngines).every((s) => s && s.initialOutputsLoaded.resolved === true)) {
                this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.SCENE.SCENE_BOUNDING_BOX_EMPTY, {
                    viewportId: this._renderingEngine.id,
                });
            }
        }
        this._renderingEngine.renderingManager.evaluateTextureUnitCount(this._renderingEngine.lightLoader.shadowMapCount +
            this._renderingEngine.materialLoader.maxMapCount);
        /**
         *
         * Three.js texture upload and compiling
         * This step is needed as three.js would compile the shaders and initialize the texture on the first render call instead.
         *
         */
        // we initialize all texture and then clear the cache
        const threeJsTextureCache = this._renderingEngine.materialLoader.threeJsTextureCache;
        for (const key in threeJsTextureCache) {
            if (threeJsTextureCache[key].usage === 0) {
                threeJsTextureCache[key].texture.dispose();
                delete threeJsTextureCache[key];
            }
            else if (threeJsTextureCache[key].initialized === false) {
                this._renderingEngine.renderer.initTexture(threeJsTextureCache[key].texture);
                threeJsTextureCache[key].initialized = true;
            }
        }
        // we compile the shaders
        this._renderingEngine.renderer.compile(this._renderingEngine.scene, this._hiddenCamera);
        this._performanceEvaluator.endSection("sceneTreeUpdate." + this._lastRootVersion);
    }
    /**
     * Remove obsolete child nodes from the converted object
     */
    cleanupObsoleteChildren(treeNode, convertedObject) {
        // remove all child nodes in the transformed object that do not exist anymore
        // the filter goes also through the data items as they were already added
        const nodeIds = new Set(treeNode.children
            .filter((d) => !d.excludeViewports.includes(this._renderingEngine.id))
            .map((d) => d.id));
        const childrenToRemove = convertedObject.children.filter((oc) => {
            if (oc instanceof SDObject_1.SDObject && oc.SDtype === SDObject_1.SD_DATA_TYPE.OBJECT) {
                return !nodeIds.has(oc.SDid);
            }
            else {
                return false;
            }
        });
        childrenToRemove.forEach((cTR) => {
            cTR.traverse((o) => {
                if (o instanceof SDObject_1.SDObject && o.SDtype !== SDObject_1.SD_DATA_TYPE.OBJECT) {
                    (0, SceenTreeManagerUtils_1.removeData)(this._renderingEngine, o);
                }
                else if (!(o instanceof SDObject_1.SDObject) &&
                    o.userData.SDtype !== undefined) {
                    (0, SceenTreeManagerUtils_1.removeData)(this._renderingEngine, o);
                }
            });
            convertedObject.remove(cTR);
        });
    }
    /**
     * Remove obsolete data items from the converted object
     */
    cleanupObsoleteData(treeNode, convertedObject) {
        // remove all data items that do not exist anymore
        const dataMap = new Map(treeNode.data.map((d) => [d.id, d.version]));
        const dataToRemove = convertedObject.children.filter((oc) => {
            if (!(oc instanceof SDObject_1.SDObject)) {
                const version = dataMap.get(oc.userData.SDid);
                if (version !== undefined) {
                    if (version !== oc.userData.SDversion) {
                        // version is different
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    // id not included anymore
                    return true;
                }
            }
            else {
                return false;
            }
        });
        dataToRemove.forEach((dTR) => {
            (0, SceenTreeManagerUtils_1.removeData)(this._renderingEngine, dTR);
            convertedObject.remove(dTR);
        });
    }
    /**
     * Check if a node is visible in the current viewport
     */
    isNodeVisible(treeNode) {
        return (treeNode.visible &&
            !treeNode.excludeViewports.includes(this._renderingEngine.id) &&
            !(treeNode.restrictViewports.length > 0 &&
                !treeNode.restrictViewports.includes(this._renderingEngine.id)));
    }
    /**
     * Process a child node by creating it if needed, updating it, and syncing bounding boxes
     */
    processChildTreeNode(treeNodeChild, convertedObject, childConvertedObject, filter, isVisibleInHierarchy) {
        if (!childConvertedObject) {
            const newChild = new SDObject_1.SDObject(treeNodeChild.id, treeNodeChild.version);
            const oldChild = treeNodeChild.convertedObject[this._renderingEngine.id];
            treeNodeChild.convertedObject[this._renderingEngine.id] = newChild;
            if (treeNodeChild.updateCallbackConvertedObject)
                treeNodeChild.updateCallbackConvertedObject(newChild, oldChild, this._renderingEngine.id);
            convertedObject.add(newChild);
            this.updateNode(treeNodeChild, newChild, filter, isVisibleInHierarchy);
        }
        else if (childConvertedObject.SDversion !== treeNodeChild.version ||
            this._newRendererType) {
            // if the version is different, update the child
            this.updateNode(treeNodeChild, childConvertedObject, filter, isVisibleInHierarchy);
            childConvertedObject.SDversion = treeNodeChild.version;
        }
        else {
            this.updateNode(treeNodeChild, childConvertedObject, filter, isVisibleInHierarchy);
        }
    }
    /**
     * Reset and initialize bounding boxes for a node
     */
    resetBoundingBoxes(treeNode) {
        // reset the general bounding box of the current node
        // it will be recomputed in the following steps
        treeNode.boundingBox.reset();
        // create the specific BB if it doesn't exist yet
        if (!treeNode.boundingBoxViewport[this._renderingEngine.id])
            treeNode.boundingBoxViewport[this._renderingEngine.id] = new viewer_shared_math_1.Box();
        // reset the specific bounding box of the current node
        // it will be recomputed in the following steps
        treeNode.boundingBoxViewport[this._renderingEngine.id].reset();
    }
    /**
     * Resolves the converted object for a node, handling cases where it doesn't exist
     */
    resolveConvertedObject(treeNode, filter, visibleInHierarchy) {
        // check if there is a converted object
        if (treeNode.convertedObject[this._renderingEngine.id]) {
            return treeNode.convertedObject[this._renderingEngine.id];
        }
        else {
            // the node has not been converted yet
            // go up the hierarchy until a converted object is found
            let parent = treeNode.parent;
            while (parent) {
                if (parent.convertedObject[this._renderingEngine.id]) {
                    this.updateNode(parent, parent.convertedObject[this._renderingEngine.id], filter, visibleInHierarchy);
                    return;
                }
                else {
                    parent = parent.parent;
                }
            }
            // no converted object found in the hierarchy
            // update the whole scene tree
            this.updateSceneTree(this._tree.root);
            return;
        }
    }
    /**
     * Union child bounding boxes with parent bounding boxes
     */
    unionChildBoundingBoxes(treeNode, treeNodeChild, isVisible) {
        // adjust the general BB
        if (!treeNodeChild.boundingBox.isEmpty())
            treeNode.boundingBox.union(treeNodeChild.boundingBox);
        // adjust the specific BB
        if (treeNodeChild.boundingBoxViewport[this._renderingEngine.id] &&
            !treeNodeChild.boundingBoxViewport[this._renderingEngine.id].isEmpty()) {
            // only do this if the node is
            // 1. visible
            // 2. no included in the "excludeViewports"
            // 3. if there are "restrictViewports", it needs to be in them
            if (isVisible)
                treeNode.boundingBoxViewport[this._renderingEngine.id].union(treeNodeChild.boundingBoxViewport[this._renderingEngine.id]);
        }
    }
}
exports.SceneTreeManager = SceneTreeManager;
//# sourceMappingURL=SceneTreeManager.js.map